import React, { useEffect, useState } from 'react';
import adminprofileStyle from './AdminAuthorProfilePage.module.css'
import MainHeader from '../../components/mainheader/MainHeader'
import FormheadMobil from '../../components/formheadmobilComponent/formheadMobil'
import AuthorprofileInfo from '../../components/authorprofileComponent/authorprofileInfo'
import ContactInfo from '../../components/contactComponent/contactInfo'
import MoreInfo from '../../components/moreinfoComponent/moreInfo'
import BiographyInfo from '../../components/biographyComponent/biographyInfo'
import BooklistInfo from '../../components/booklistComponent/booklistInfo'
import NotetoaudienceInfo from '../../components/notetoaudienceComponent/notetoaudienceInfo'
import NotetohostInfo from '../../components/notetohostComponent/notetohostInfo'
import FormHead from '../../components/formheadComponent/formHead'
import { LuPencilLine } from "react-icons/lu"
import { useMediaQuery } from 'react-responsive';
import { useParams } from "react-router-dom";
import axios from "axios";
require('typeface-poppins')

export default function AdminAuthorProfilePage() {

    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

    const { id } = useParams();
    const [proimage, setProimage] = useState('')
    const [authorsbook, setBooks] = useState([]);
    const [user, setUser] = useState(null); // State to hold user details
    const [category1, setCategory1] = useState('');
    const [genre1, setGenre1] = useState('');
    const [region1, setRegion1] = useState('');
    const [error, setError] = useState(null); // State to handle errors
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Fetch user details from the backend
        const fetchUserDetails = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_author_data.php?id=${id}`);
                if (response.data.success) {

                    setProimage(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/images/author/${id}.jpg`);

                    setUser(response.data.user);
                    setBooks(response.data.authorsbook);
                    setGenre1(response.data.genres);
                    setRegion1(response.data.regions);
                    setCategory1(response.data.categories);
                } else {
                    setError(response.data.message);
                }
            } catch (err) {
                setError("Failed to fetch user details. Please try again later.");
            } finally {
                setLoading(false);
            }
        };
        fetchUserDetails();
    }, [id]);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }


    // BookList popup
    /*const bookListpop = async () => {
        const { value: formData } = await MySwal.fire({
        title: `My Books: ${user.f_name} ${user.l_name}`,
        html: (
        <div className='bookListpopup'>
            <div className='container'>
                <BooklistIsbn />     
            </div>      
        </div>  
        ),
        showCancelButton: true,
        showCloseButton: true,        
        confirmButtonText: 'Save',
        focusConfirm: false,        
        customClass: {                
        popup: `${adminprofileStyle.mainbooklistPopup}`,
        title: `${adminprofileStyle.mainbooklistTitle}`,
        confirmButton: `${adminprofileStyle.mainbooklistsaveButton}`,             
        closeButton: `${adminprofileStyle.mainbooklistcloseButton}`,
        cancelButton: `${adminprofileStyle.mainbooklistcancelbutton}`,
        },
        preConfirm: async () => {
            // Check if either `nji` or `delrec` is not empty
            if (nji.length > 0 || delrec.length > 0) {
                try {
                    // Make the POST request to the API
                    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/addbookstoauthor.php`, {
                        add: nji,  // The books to be added
                        del: delrec,  // The books to be removed
                        auid: id  // Author ID
                    });
        
                    // Check the API response
                    if (response.data.success) {
                        //alert('Books successfully added or removed.');
                        // You can handle any further logic on success here
                        await MySwal.fire({
                        icon: 'success',
                        title: 'Books successfully added or removed!',
                        showConfirmButton: false,
                        timer: 2000, // auto-close after 2 seconds
                        });
                        window.location.reload();
                    } else {
                        alert('Failed to add or remove books.');
                    }
                } catch (err) {
                    // Handle any errors that occur during the API request
                    alert('Error adding or removing books. Please try again.');
                    console.error(err);
                }
            } else {
                // Alert when no changes are made
                alert('Please add or remove books before saving.');
            }
        },
        });
        if (formData) {
            console.log('Registration data:', formData);
        }
    }; */

    return (
        <>
            <MainHeader />
            <div className={adminprofileStyle.mainauthorprofilepage}>
                {isMobile ? (
                    <div className={adminprofileStyle.mobilauthorprofiletopbar}>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-lg-12'>
                                    <FormheadMobil />
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className={adminprofileStyle.desktopauthorprofiletopbar}>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-lg-12'>
                                    <FormHead />
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {isMobile ? (
                    <div className={adminprofileStyle.mobilmainprofileContent}>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-xl-12 col-xxl-12'>
                                    <AuthorprofileInfo mobilImg={proimage} />
                                </div>
                                <div className='col-xl-12 col-xxl-12'>
                                    <ContactInfo fName={user.f_name} lName={user.l_name} cMail={user.email_id} cMobil={user.phone} web={user.website} zip={user.zipcode} />
                                </div>
                                <div className='col-xl-12 col-xxl-12'>
                                    <MoreInfo region={user.region} category={user.category} willing={user.willingtotravel ? 'yes' : 'No'} genre={user.genre}
                                        authorIllu={user.authororillustrator === 0 ? 'Author' : user.authororillustrator === 1 ? 'Illustrator' : 'Author & Illustrator'} />
                                </div>
                                <div className='col-xl-12 col-xxl-12'>
                                    <BiographyInfo bio={user.biography} />
                                </div>
                                <div className='col-xl-12 col-xxl-12'>
                                    <BooklistInfo authorbookdata={authorsbook} />
                                </div>
                                <div className='col-xl-12 col-xxl-12'>
                                    <NotetoaudienceInfo noteFamily={user.notetofamilies} />
                                </div>
                                <div className='col-xl-12 col-xxl-12'>
                                    <NotetohostInfo noteHost={user.notetohost} />
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className={adminprofileStyle.desktopmainprofileContent}>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-xl-4 col-xxl-4'>
                                    <div className='row'>
                                        <div className="col-xl-12">
                                            <div className={adminprofileStyle.authorprofileBox}>
                                                <div className={adminprofileStyle.authorprofilePreview}>
                                                    <div className={adminprofileStyle.authorprofileimageWrap}>
                                                        <img src={proimage} className='img-fluid w-100 h-100' />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="col-xl-12">
                                            <div className={adminprofileStyle.authorcontactinfoBox}>
                                                <h4>Contact Info</h4>
                                                <div className={adminprofileStyle.authorinfobox}>
                                                    <h5>Name</h5>
                                                    <p>{user.f_name} {user.l_name}</p>
                                                </div>
                                                <div className={adminprofileStyle.authorinfobox}>
                                                    <h5>Website</h5>
                                                    <a href='#'>{user.website}</a>
                                                </div>
                                                <div className={adminprofileStyle.authorinfobox}>
                                                    <h5>Email Address</h5>
                                                    <p>{user.email_id}</p>
                                                </div>
                                                <div className={adminprofileStyle.authorinfobox}>
                                                    <h5>Phone</h5>
                                                    <p>{user.phone}</p>
                                                </div>
                                                <div className={`${adminprofileStyle.authorinfobox} pb-0`}>
                                                    <h5>Hometown Zip Code</h5>
                                                    <p>{user.zipcode}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row mb-4'>
                                        <div className="col-xl-12">
                                            <div className={adminprofileStyle.authormoreinfoBox}>
                                                <h4>More Info</h4>
                                                <div className='row mb-4 align-items-center'>
                                                    <div className='col-sm-6'>
                                                        <h5>Willing to Travel?</h5>
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <p>{user.willingtotravel ? 'yes' : 'No'}</p>
                                                    </div>
                                                </div>
                                                <div className='row mb-4 align-items-center'>
                                                    <div className='col-sm-6'>
                                                        <h5>Region</h5>
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <p>{user.region}</p>
                                                    </div>
                                                </div>
                                                <div className='row mb-4 align-items-center'>
                                                    <div className='col-sm-6'>
                                                        <h5>Category</h5>
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <p>{user.category}</p>
                                                    </div>
                                                </div>
                                                <div className='row mb-4 align-items-center'>
                                                    <div className='col-sm-6'>
                                                        <h5>Genre</h5>
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <p>{user.genre}</p>
                                                    </div>
                                                </div>
                                                <div className='row align-items-center'>
                                                    <div className='col-sm-6'>
                                                        <h5>Author or Illustrator</h5>
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <p>{user.authororillustrator === 0 ? 'Author' :
                                                            user.authororillustrator === 1 ? 'Illustrator' :
                                                                'Author & Illustrator'}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-xl-8 col-xxl-8'>
                                    <div className='row'>
                                        <div className='col-xl-12'>
                                            <div className={adminprofileStyle.authorBiographybox}>
                                                <h5>Biography</h5>
                                                <p>{user.biography}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-xl-12'>
                                            <div className={adminprofileStyle.authorbooklistBox}>
                                                <div className={adminprofileStyle.authorbookheadBox}>
                                                    <h4>Book List</h4>
                                                    <button className={`${adminprofileStyle.editButtn} btn btn-light`} >Edit
                                                        <LuPencilLine className={`${adminprofileStyle.editButtonicon} ms-1`} />
                                                    </button>
                                                </div>
                                                <div className='table-responsive'>
                                                    <table className={`${adminprofileStyle.authorbooklistTable} table table-borderless`}>
                                                        <thead>
                                                            <tr>
                                                                <th class={`w-50`}>Title</th>
                                                                <th>ISBN</th>
                                                                <th className='text-end'>Price</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {authorsbook.map((book, index) => (
                                                                <tr key={index}>
                                                                    <td class={`w-50`}>{book.title}</td>
                                                                    <td>{book.isbn}</td>
                                                                    <td className='text-end'>${book.price}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-xl-12'>
                                            <div className={adminprofileStyle.authornotetofamiliesBox}>
                                                <h5>Note to Audience</h5>
                                                <p>{user.notetofamilies}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-xl-12'>
                                            <div className={adminprofileStyle.authornotetohostBox}>
                                                <h5>Note to Hosts</h5>
                                                <p className='pb-4'>{user.notetohost}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}